<template>
	<v-container>
		<v-row class="contentRow" align="center">
			<v-col cols="12">
				<h1>Request Sustainability Self-Assessment From a Supplier</h1>
			</v-col>

			<v-col cols="12">
				<v-stepper class="elevation-0" v-model="step">
					<v-stepper-header class="elevation-0">
						<v-stepper-step
							:editable="step != 3"
							edit-icon="fas fa-check"
							:complete="step > 1 || step =='2a' || step =='2b'"
							step="1"
						>
							Select suppliers
						</v-stepper-step>

						<v-divider />

						<!-- <v-stepper-step
							:editable="step != 3 && (step > 2 || step == '2a' || step=='2b')"
							:complete="step > 2 && (selectedRecipients.length > 0)"
							step="2a"
						>
							Choose existing suppliers
						</v-stepper-step>
						<v-divider /> -->

						<v-stepper-step
							:complete="step > 2 && (selectedInvitationCodes.length > 0)"
							step="2"
						>
							Invite supplier
						</v-stepper-step>
						<v-divider />
						<v-stepper-step
							step="3"
						>
							Result
						</v-stepper-step>
					</v-stepper-header>
					<v-stepper-content height="200px" step="1">
						<v-row>
							<v-col class="text-left">
								<v-btn color="secondary" depressed @click="step = '2a'">
									Choose existing suppliers
								</v-btn>
								<v-btn
									@click="step = '2b';
										$store.dispatch(
											'connections/invitationcodes/setInvitationCodeModalOpen',
											true
										)"
									outlined
									color="secondary"
									depressed
									class="ml-3"
								>
									<!-- <v-icon left>fas fa-plus</v-icon>Create new invitation -->
									<v-icon left>fas fa-plus</v-icon>Add new supplier
								</v-btn>
							</v-col>
							<v-col class="text-right">
								<v-btn 
									color="primary" 
									:disabled="true"
									>
									Next<v-icon right>fas fa-arrow-right</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-stepper-content>

					<v-stepper-content height="200px" step="2a">
						<v-card class="elevation-0">
							<v-card-title>Choose Recipient</v-card-title>
							<v-card-subtitle
								>Please choose either a connection or an invitation code as a
								recipient for the CSR request</v-card-subtitle>

							<v-card-text>
								<v-select
									:items="filteredSupplier"
									label="Suppliers"
									v-model="selectedRecipients"
									multiple
								>
									<template v-slot:prepend-item>
										<v-list-item>
											<v-list-item-content>
												<v-text-field 
													v-model="supplierSearch" 
													placeholder="Search Supplier" 
													autofocus
													append-icon="fa fa-close"
													@click:append="clearSearch('supplierSearch')"
												></v-text-field>
											</v-list-item-content>
										</v-list-item>
									</template>
								</v-select>
							</v-card-text>
						</v-card>
						<v-row>
							<v-col class="text-left">
								<v-btn
									color="primary"
									outlined
									class="ml-4"
									@click="previousStep"
								>
									<v-icon left>fas fa-arrow-left</v-icon> Previous Step
								</v-btn>
							</v-col>
							<v-col class="text-right">
								<v-btn 
									color="primary" 
									class="mr-4" 
									:disabled="!(selectedRecipients.length > 0)" 
									@click="sendNotification()"
									>
									Send CSR Request<!-- <v-icon right>fas fa-arrow-right</v-icon> -->
									<v-icon right>fas fa-paper-plane</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-stepper-content>

					<v-stepper-content height="200px" step="2b">
						<!-- <v-btn
							outlined
							color="secondary"
							depressed
							class="mb-2"
							@click="
							$store.dispatch(
								'connections/invitationcodes/setInvitationCodeModalOpen',
								true
							)"
						>
							<v-icon left>fas fa-plus</v-icon>Add new supplier
						</v-btn> -->
						<AddNewInvitationCode
							@updateInvitationCode="updateInvitationCode"
						/>
						<NewCodeDisplay />

						<v-row>
							<v-col class="text-left">
								<v-btn
									color="primary"
									outlined
									@click="previousStep"
								>
									<v-icon left>fas fa-arrow-left</v-icon> Previous Step
								</v-btn>
							</v-col>
							<v-col class="text-right">
								<v-btn 
									color="primary" 
									:disabled="!(selectedInvitationCodes.length > 0)" 
									@click="step='3'"
									>
									Send CSR Request<!-- <v-icon right>fas fa-arrow-right</v-icon> -->
									<v-icon right>fas fa-paper-plane</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-stepper-content>

					<v-stepper-content height="200px" step="3">
						<div v-if="!error">
							<!-- <v-icon color="success" class="mx-auto" x-large
							>fas fa-check-circle</v-icon> -->
							<!-- <h2>Success</h2> -->
							<div style="border: 2px solid #227e85;" align="center">
								<v-img
									alt="Success Icon"
									:src="require('../assets/twemoji/success.svg')"
									width="75"
									class="mx-auto my-8"
								/>
								<p style="font-size: 20px;">Successfully sent CSR Request!</p>
							</div>
							<v-btn color="primary" @click="resetForm" align="center" class="mt-5">
								Send Another CSR Request
								<v-icon right>fas fa-plus</v-icon>
							</v-btn>
						</div>
						<div v-else>
							<div style="border: 2px solid red;" align="center">
								<v-icon color="error" class="max-auto" x-large>
									fas fa-times-circle
								</v-icon>
								<h2>Error</h2>
								<p>Could not complete CSR Request!</p>
								<p>{{ error }}</p>
							</div>
							<v-btn color="primary" @click="resetForm" align="center" class="mt-5">
								Send New CSR Request
								<v-icon right>fas fa-undo-alt</v-icon>
							</v-btn>
						</div>

					</v-stepper-content>
				</v-stepper>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import SupplierAPI from "../api/csr/supplier"
import CsrAPI from "../api/csr/csr"
import LoadingState from "../consts/LoadingState"
import AddNewInvitationCode from "../components/InvitationCodes/AddNew"
import NewCodeDisplay from "../components/InvitationCodes/NewCodeDisplay"

export default {
	name: "CSR Request",
	components: {
		AddNewInvitationCode,
		NewCodeDisplay
	},
	data() {
		return {
			step: 1,
			selectedRecipients: [],
			suppliers: [],
			selectedInvitationCodes: [],
			error: null,
			supplierSearch: ""
		}
	},
	mounted() {
		this.fetchSuppliers()
	},
	computed: {
		filteredSupplier() {
			if (!this.supplierSearch) {
				return this.suppliers
			}

			return this.suppliers.filter((supplier) => {
				return supplier.text.toLowerCase().indexOf(this.supplierSearch.toLowerCase()) > -1
			})
		},
	},
	methods: {
		clearSearch(searchField){
			this[searchField] = ""
		},
		updateInvitationCode(updatedInvitationCode) {
			this.selectedInvitationCodes.push(updatedInvitationCode)
			if (updatedInvitationCode) {
				this.selectedRecipients = []
			}
		},
		fetchSuppliers() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Fething data...",
				{ root: true }
			)
			this.suppliers = []
			SupplierAPI.getSuppliersWithoutCsr()
				.then((res) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
					for (let entry of res) {
						this.suppliers.push({
							value: entry.clientID,
							text: `${entry.name}`,
							remove: null,
						})
					}
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		sendNotification() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Fething data...",
				{ root: true }
			)
			CsrAPI.sendInvitation(this.selectedRecipients)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
					this.error = null
					this.step = 3 // If Notification is successfully sent, increase step
				})
				.catch((error) => {
					this.error = error
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		resetForm() {
			this.selectedRecipients = []
			this.selectedInvitationCodes = []
			this.step = 1
			this.error = null
		},
		previousStep() {
			if (this.step == 1 || this.step > 2) {
				return
			} else if (this.step == "2a" || this.step == "2b") {
				this.step = 1
			} else if (this.step == 2) {
				this.step = 1
			}
		},
	},
}
</script>